import React, { useState, useEffect } from "react";
import {ChevronLeft, ChevronRight} from 'lucide-react';
import { motion, AnimatePresence } from "framer-motion";
//react-feather
import imgUnswActivity from '../../image-assets/unsw-activity-page.jpg';
import imgUnswCourse from '../../image-assets/unsw-course-page.jpg';
import imgUnswWeek from '../../image-assets/unsw-week-page.jpg';

const ImageSlider = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [  
    imgUnswCourse,
    imgUnswWeek,
    imgUnswActivity,
  ];

  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }

  const openModal = (index) => {
    setCurrent(index);
    setIsOpen(true);
  }  

  const closeModal = () => setIsOpen(false);

  // Close when pressing Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="ml-0 mb-4 w-full md:w-1/3 ml-3.5 pt-2 relative">

      {/* Thumbnails */}      
      <img
        src={images[0]}
        alt={`Slide 1`}
        className="rounded shadow hover:opacity-80 transition"      
        onClick={() => openModal(0)}
      />
      
      {isOpen && (
        
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"          
        >
          <div className="absolute inset-0 cursor-pointer" 
               onClick={closeModal} 
               />
                <AnimatePresence mode="wait">
                  <motion.img
                    key={current}
                    src={images[current]}
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -200, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    className="rounded-xl max-h-[80vh] object-contain"
                  />
                </AnimatePresence>
                <button
                onClick={prevSlide}
                className="absolute top-1/2 left-4 -translate-y-1/2 bg-white/50 hover:bg-white/70 p-2 rounded-full"
                >
                  <ChevronLeft />
                </button>

                {/* Arrows */}      
                <button
                  onClick={nextSlide}
                  className="absolute top-1/2 right-4 -translate-y-1/2 bg-white/50 hover:bg-white/70 p-2 rounded-full"
                >
                  <ChevronRight />
                </button>
               {/* Dots */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrent(index)}
                      className={`w-3 h-3 rounded-full transition-all ${
                        index === current ? "bg-white" : "bg-gray-400/50"
                      }`}
                    />
                  ))}
                </div>  
        </div>
      )}

    </div>
  );
};

export default ImageSlider;